import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import HeroSlider from "@/pages/home/components/HeroSlider";
import IntroSection from "@/pages/home/components/IntroSection";
import ServiceCards from "@/components/feature/ServiceCards";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactCTA from "@/pages/home/components/ContactCTA";

export default function HomeFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="NetBasis International - linking people & business"
        description="Implantation réussie et croissance B2B pour les fabricants étrangers de TIC en Allemagne, Autriche et Suisse."
        ogUrl="https://net-basis.net/fr"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <HeroSlider
          texts={{
            slide1_title: "Nouveaux marchés, nouvelles affaires ... aucun risque !",
            slide2_title: "Avec nous, en plein cœur de l'Europe !",
            slide3_title: "L'Allemagne (DACH) – Votre réussite avec un partenaire local !",
            slide4_title: "Plus forts ensemble !",
            slide4_subtitle: "Développement commercial\nConseil\nManagement de transition\nFormation et coaching",
            slide5_title: "Lancez-vous !",
            prev_slide: "Diapositive précédente",
            next_slide: "Diapositive suivante",
            slide_label: "Diapositive {{number}}",
            alts: [
              "Un doigt touche un globe numérique connecté pour entrer à faible risque sur le marché TIC.",
              "Un doigt marque l'Europe sur une carte du monde connectée pour l'entrée sur le marché TIC.",
              "Carte bleue de l'Allemagne avec ses Länder pour un partenariat TIC sur le marché DACH.",
              "Un homme d'affaires utilise une interface numérique pour des services TIC sur le marché DACH.",
              "Un doigt active une icône numérique de départ pour réussir son entrée sur le marché TIC européen.",
            ],
          }}
        />

        <IntroSection
          texts={{
            title: "NetBasis International - linking people & business",
            heading:
              "Votre partenaire opérationnel pour une entrée réussie sur le marché de la région DACH. Nous soutenons et pilotons vos activités locales – sur mesure, que ce soit par la prise en charge de l'ensemble de vos opérations ou de manière flexible sur des fonctions spécifiques.",
            paragraph1:
              "Le développement, la croissance et l'expansion des affaires sur de nouveaux marchés doivent avant tout être synonymes de réussite, de rapidité, d'efficacité, de rentabilité et de sécurité pour les entreprises étrangères. Les études de marché interminables, les stratégies complexes aux processus décisionnels flous ou le manque d'accès direct au marché cible constituent invariablement une mauvaise approche. De plus, les fabricants souhaitent souvent pénétrer un nouveau marché sans investissements initiaux majeurs.",
            paragraph2:
              "C'est précisément là que NetBasis International s'impose comme le partenaire idéal à vos côtés. Depuis près de 20 ans, nous accompagnons et soutenons avec succès les entreprises étrangères du secteur des TIC sur des marchés attractifs mais exigeants – avec une focalisation claire sur l'espace économique germanophone (la région DACH).",
            strong_name: "NetBasis International",
          }}
        />

        <ServiceCards
          namespace="home"
          titleKeys={[
            "services.service1_title",
            "services.service2_title",
            "services.service3_title",
            "services.service4_title",
          ]}
          descriptionKeys={[
            "services.service1_description",
            "services.service2_description",
            "services.service3_description",
            "services.service4_description",
          ]}
          readMoreKey="services.read_more"
          texts={{
            titles: [
              "Développement commercial",
              "Conseil",
              "Management de transition",
              "Formation et coaching",
            ],
            descriptions: [
              "Succès sur le marché DACH ? Nous vous ouvrons la voie ! Avec nous, les portes s'ouvrent. On agit et on concrétise !",
              "Savoir comment faire ? Nous vous éclairons ! Nous conseillons avec clairvoyance. Nous protégeons votre projet !",
              "Besoin temporaire ? Nous y répondons avec brio ! Nous comblons le vide. Nous vous sécurisons !",
              "Nouveaux marchés en vue ? Nous vous préparons ! Nous formons à la pratique. Nous sécurisons votre projet !",
            ],
            readMore: "En savoir plus",
          }}
        />

        <AboutSection
          texts={{
            title: "NetBasis International - drive to excellence with excellent drivers!",
            paragraph1:
              "En tant qu'experts reconnus basés en Allemagne – le marché européen le plus important – l'équipe de NetBasis International vous aide à identifier les barrières à l'entrée, évaluer les options stratégiques, développer des concepts marketing réalistes, trouver les partenaires adéquats et cibler directement vos clients potentiels. Fiables et orientés résultats, nous offrons une large gamme de services : de la planification d'entrée sur le marché au développement commercial, en passant par la vente, le marketing, les relations publiques, le support technique et, si nécessaire, l'acquisition de talents.",
            paragraph2:
              "En collaborant avec nous, vous bénéficiez d'un point de contact unique pour l'intégralité de votre projet. Vous accédez immédiatement au savoir-faire indispensable et à l'expertise opérationnelle nécessaires à votre réussite commerciale. Grâce à notre approche pragmatique, nous définissons ensemble les conditions et les exigences spécifiques de vos pays cibles.",
            paragraph3:
              "Vous avez le choix quant à la manière de solliciter notre expertise : Nous pouvons prendre en charge l'intégralité du projet et agir en tant que véritable structure locale sur place pour une période déterminée ou indéterminée. Alternativement, nous vous soutenons de manière ciblée sur des missions individuelles, vous accompagnons à titre purement consultatif sur votre propre trajectoire, ou coopérons avec vous dans le domaine de la formation et du coaching.",
            paragraph4:
              "Quels que soient les services que vous choisissez : NetBasis International coordonne parfaitement l'ensemble des ressources et des mesures pour faire progresser votre entreprise de manière efficace.",
            strong_name: "NetBasis International",
          }}
        />

        <ContactCTA
          texts={{
            title: "Contactez-nous directement maintenant.",
            cta_button: "Formulaire de contact",
            link_url: "/fr/contact",
          }}
        />
      </main>

      <Footer />
    </div>
  );
}